import imagesLoaded from "imagesloaded";
import Packery from "packery";
import Player from "@vimeo/player";
import axios from "axios";
import { EventHandler } from "./modules/eventHandler";
import * as Videos from "./modules/videos";
import * as Jobs from "./modules/jobs";
import * as infoBar from "./modules/infobar";
import * as Utils from "./modules/utils";

var body = document.querySelector("body"),
    header = document.querySelector(".js-header"),
    winW,
    winH,
    winScrollT = 0,
    loadingOverlay = document.querySelector(".js-loading-overlay"),
    loadingContents = document.querySelectorAll(".js-loading-contents"),
    lockupBlocks = document.querySelector(".js-lockup-blocks"),
    sizingTimeout = false,
    scrollingTimeout = false,
    pageContents = document.querySelector(".js-page-contents"),
    pageVisible = false,
    scrollTop = document.querySelector(".js-scroll-top"),
    lockupBlockData = {},
    packeryContainerEl,
    pckryInstance,
    projectOverlayTransitionT = 500, // From CSS
    stateObj = {
        time: Date.now(),
    },
    touchStartEvents = "touchstart  pointerdown  MSPointerDown",
    touchMoveEvents = "touchmove  pointermove  MSPointerMove",
    touchEndEvents = "touchend  pointerup  MSPointerUp",
    userAgent = {
        string: navigator.userAgent.toLowerCase(),
    },
    touchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0,
    dragging = false,
    preventAction = false,
    infiniteScrollAjaxCall,
    projectArray = [],
    pageLoad = true,
    // This is a stripped down version of the ftellipsis.js vendors test
    sizing = function () {
        winW = window.innerWidth;
        winH = window.innerHeight;
    },
    scrolling = function () {},
    appendSizing = function (newSizing) {
        var currentSizing = sizing;

        sizing = function () {
            currentSizing();

            newSizing();
        };
    },
    appendScrolling = function (newScrolling) {
        var currentScrolling = scrolling;

        scrolling = function (valueSet) {
            currentScrolling(valueSet);

            newScrolling();
        };
    },
    raf = function (callback) {
        window.requestAnimationFrame(callback);
    },
    animateBody = function (target, duration) {
        // Animate both elements for wider browser support
        window.scroll({
            top: target,
            behavior: "smooth",
        });
    },
    showOverlay = function (overlay) {
        if (!!overlay.forEach) {
            overlay.forEach((el) => {
                el.classList.add("reveal");
            });

            return;
        }

        overlay.classList.add("reveal");
    },
    hideOverlay = function (overlay) {
        if (!!overlay.forEach) {
            overlay.forEach((el) => {
                el.classList.remove("reveal");
            });

            return;
        }

        overlay.classList.remove("reveal");
    },
    onPageVisible = function () {
        // Set the flag to say that page visible is true
        pageVisible = true;
    },
    appendPageVisible = function (newVisible) {
        var currentVisible = onPageVisible;

        // If the page is already visible, run this straight away
        if (pageVisible) {
            newVisible();
            return;
        }

        // Add the new function to the page visible function
        onPageVisible = function () {
            currentVisible();

            newVisible();
        };
    },
    hidePage = function () {
        // Set the transition to instant
        loadingOverlay.classList.add("instant");

        showOverlay(loadingOverlay);

        // After it is visible, add the transiiton back again
        setTimeout(function () {
            loadingOverlay.classList.remove("instant");
        }, 10);

        // Hide the contents
        loadingContents.forEach((el) => el.classList.remove("fade-in"));
    },
    showPage = function () {
        // If this is the first load, make sure we start back at the top of the page to prevent
        // any issues with infinite scroll page starting you back at a random point on refresh
        if (pageLoad) {
            // Browser fires the jump to position at an indeterminate time after page load
            // using the scroll time fixes this and prevents jumps in the side bar
            animateBody(0);
        }

        hideOverlay(loadingOverlay);

        // Show the page contents
        setTimeout(function () {
            loadingContents.forEach((el) => el.classList.add("fade-in"));
        }, 300);

        if (pageLoad) {
            // After the page has faded back in, run the onPageVisible function and give the
            // loading contents a transition for fading out again
            setTimeout(function () {
                loadingContents.forEach((el) =>
                    el.classList.add("symmetrical-transitions")
                );

                onPageVisible();
            }, 600);
        }

        // Set the flag
        pageLoad = false;
    },
    setLastPointerUp = function (e) {
        // If this is an ie touch device with the pointerup event
        if ("pointerup  MSPointerUp".indexOf(e.type) > -1) {
            // Set the time for the last event as now
            lastPointerUp = Date.now();
        }
    },
    generalListenersInit = function () {
        var getCoOrds = function (e) {
            // Cross browser safety
            if (e.originalEvent.touches) {
                e = e.originalEvent.touches[0];
            }

            return {
                x: Math.round(e.pageX),
                y: Math.round(e.pageY),
            };
        };

        EventHandler.addEventListener(
            "resize",
            () => {
                if (!sizingTimeout) {
                    sizingTimeout = setTimeout(function () {
                        sizingTimeout = false;

                        raf(sizing);
                    }, 50);
                }
            },
            "window"
        );

        EventHandler.addEventListener(
            "scroll",
            () => {
                if (!scrollingTimeout) {
                    scrollingTimeout = setTimeout(function () {
                        scrollingTimeout = false;

                        raf(scrolling);
                    }, 50);
                }
            },
            "window"
        );

        if (touchDevice) {
            // Check if touchend events are actually part of a drag
            body.addEventListener(touchStartEvents, function (e) {
                var touchStartCoOrds = getCoOrds(e);

                // Reset the dragging flag
                dragging = false;

                // Remove any previous listeners and start listening again
                body.removeEventListener(touchMoveEvents);
                body.addEventListener(touchMoveClasses, function (e) {
                    var touchMoveCoOrds = getCoOrds(e);

                    // If we have moved from the start
                    if (
                        touchMoveCoOrds.x !== touchStartCoOrds.x ||
                        touchMoveCoOrds.y !== touchStartCoOrds.y
                    ) {
                        // Remove these listeners as we are done
                        body.removeEventListener(touchMoveEvents);
                        // Set the flag
                        dragging = true;
                    }
                });
            });
        }
    },
    parseHash = function () {
        // Remove the # from the hash and lowercase
        return window.location.hash.substring(1).toLowerCase();
    },
    parseState = function () {
        var path = window.location.pathname.toLowerCase();

        // Remove the '/' from the string
        return path.substring(1);
    },
    parseUrl = function () {
        return parseState();
    },
    workLinkInit = function () {
        var targetItem = document.querySelector(".js-work-target"),
            scrollInit = function () {
                var pathname = window.location.pathname,
                    initiallyInPathname = parseState() === "work",
                    initiallyInHash = parseHash() === "work",
                    action = function () {
                        var target = targetItem.offsetTop;

                        if (winW < 768) {
                            target -= parseInt(
                                window
                                    .getComputedStyle(
                                        targetItem.querySelectorAll(
                                            ".js-lockup-block"
                                        )[0]
                                    )
                                    .getPropertyValue("margin-bottom")
                            );
                        } else {
                            target +=
                                parseInt(
                                    window
                                        .getComputedStyle(
                                            targetItem.querySelectorAll(
                                                ".js-spacer"
                                            )[0]
                                        )
                                        .getPropertyValue("border-top-width")
                                ) - header.clientHeight;
                        }

                        animateBody(target);
                    };

                // If work was initially found in the pathname or the hash
                if (initiallyInPathname || initiallyInHash) {
                    // If this browser supports the history API but it was found in the hash
                    if (initiallyInHash) {
                        // Replace to remove the hash
                        window.history.replaceState(
                            stateObj,
                            null,
                            "/" + window.location.hash.substring(1)
                        );
                    }

                    appendPageVisible(action);
                }

                // On clicking the work link, check again
                document
                    .querySelectorAll(".js-scroll-work-link")
                    .forEach((el) => {
                        el.addEventListener("click", (e) => {
                            e.preventDefault();

                            window.history.pushState(
                                stateObj,
                                null,
                                window.location.origin + "/work"
                            );

                            action();
                        });
                    });
            };
        // If this page has a scroll target on it
        if (targetItem) {
            scrollInit();
        }
    },
    imageTransitionInit = function () {
        var transitionArray = [],
            mainWrapper = document.querySelector(".js-main-wrapper"),
            showContents = function (el) {
                const box = el.getBoundingClientRect();

                // After a timeout based on the left to right position to aid the human
                // readable UX, add the class to begin the transition
                setTimeout(function () {
                    if (!userAgent.androidStock) {
                        el.classList.add("transition");
                    }

                    // Add a class to indicate animations are finished
                    setTimeout(function () {
                        el.classList.add("transition-ended");
                    }, 400);

                    // Left to right, with a 25% randomness either way
                }, (box.left / winW) * 700 * (0.75 + Math.random() / 2));
            },
            calcTargets = function (firstRun) {
                var i,
                    item,
                    offset,
                    $container,
                    box,
                    threshold = 0,
                    // At mobile, the wrapper's position is influenced by the header
                    // not being fixed
                    headerFactor = winW < 768 ? header.clientHeight : 0,
                    // Take into account any translate values applied to reveal info section
                    wrapperOffset = mainWrapper.offsetTop;

                for (i = 0; i < transitionArray.length; i++) {
                    // Get the item we are looping over
                    item = transitionArray[i];

                    // Get the DOM object for this item
                    $container = item.el;

                    box = $container.getBoundingClientRect();

                    // Calculate the offset of this item
                    var scrollTop = window.scrollY;
                    offset = box.top + scrollTop;

                    // If this is not the first run, add the threshold
                    if (!firstRun) {
                        threshold = $container.clientHeight * 0.62;
                    }

                    // Calculate the targets for this item
                    item.transitionTarget =
                        offset + threshold - wrapperOffset + headerFactor;
                }
            },
            addToArray = function (els) {
                els.forEach((el) => {
                    transitionArray.push({ el: el });
                });
            },
            transitionIfInView = function () {
                var i, item, el;

                for (i = 0; i < transitionArray.length; i++) {
                    // Get the item we are looping over
                    item = transitionArray[i];

                    // Get the DOM element we are working with
                    el = item.el;

                    // If it is positioned correctly
                    if (winH >= item.transitionTarget - winScrollT) {
                        // Fade the container in
                        showContents(el);
                        // Remove this container from the array
                        transitionArray.splice(i, 1);
                        // Reduce i to compensate
                        i--;
                    }
                }
            },
            calcAndTransition = function (firstRun = false) {
                calcTargets(firstRun);

                transitionIfInView();
            };

        // Add each loading element to the transition array
        addToArray(document.querySelectorAll(".js-item-loader"));

        appendPageVisible(function () {
            calcAndTransition(true);

            calcTargets();

            appendSizing(function () {
                // Don't run this when the page contents are not visible
                if (mainWrapper.offsetWidth && mainWrapper.offsetHeight) {
                    calcAndTransition();
                }
            });

            appendScrolling(transitionIfInView);
        });

        window.appendTransitioningBlocks = function (blocks) {
            addToArray(blocks);

            calcAndTransition();
        };
    },
    packeryInstance = function () {
        // Check if there is an instance built
        return packeryContainerEl && packeryContainerEl.dataset.instance;
    },
    // Make sure the blocks are an even width so that they will divide into each other well
    sizeLockupBlocks = function (blocks, preBuild) {
        // If we weren't passed any specific blocks, get them all
        if (!blocks) {
            blocks = lockupBlocks.querySelectorAll(".js-lockup-block");
        }

        if (lockupBlocks.offsetWidth && lockupBlocks.offsetHeight) {
            // If there is a packery instance or this is pre-build, size them
            if (packeryInstance() || preBuild) {
                blocks.forEach((block) => {
                    var width;

                    // Remove any previous width set
                    block.style.width = "";

                    // Matching Packery's consistent rounding down rather than up, set the
                    // width to an integer to avoid anti-aliasing causing issues on opening
                    // up a news block and bits overflowing
                    width = Math.floor(block.getBoundingClientRect().width);

                    // If this is a super-wide with an odd width, move it to even so that
                    // the 2 narrow blocks can divide into it
                    if (
                        block.classList.contains("js-super-wide") &&
                        width % 2 !== 0
                    ) {
                        width--;
                    }

                    // Set it
                    block.style.width = width;
                });
                // Otherwise, remove any previous widths set
            } else {
                blocks.forEach((block) => {
                    block.style.width = "";
                });
            }
        }
    },
    buildPackery = function () {
        sizeLockupBlocks(null, true);

        // Set the flag on the container
        packeryContainerEl.dataset.instance = true;

        // Build initial packery instance
        pckryInstance = new Packery(packeryContainerEl, {
            itemSelector: ".js-lockup-block",
            transitionDuration: 0,
            isResizeBound: false,
            rowHeight: ".js-lockup-block",
        });
    },
    clearInfiniteScrollCall = function () {
        if (typeof infiniteScrollAjaxCall === "object") {
            infiniteScrollAjaxCall.abort();
        }
    },
    onBlocksVisible = function () {},
    blocksInit = function () {
        var lockupBlockOrder = document.querySelector(".js-lockup-block-order"),
            mobile = true,
            tablet = false,
            buildTabletOrder = function () {
                var superWide = lockupBlockData.superWide,
                    notSuperWide = lockupBlockData.notSuperWide,
                    superWideRemaining = superWide.length,
                    notSuperWideRemaining = notSuperWide.length;

                // While there are still blocks to come
                while (superWideRemaining || notSuperWideRemaining) {
                    // If there are still super wide blocks remaining,
                    if (superWideRemaining) {
                        // Add the next one, remove it, and reduce the remaining count
                        lockupBlockData.tabletOrder.push(superWide[0]);
                        superWide.splice(0, 1);
                        superWideRemaining--;
                    }

                    // If there are still not super wide blocks remaining,
                    if (notSuperWideRemaining) {
                        // Add up to the next 2, remove them, and reduce the remaining count
                        for (
                            var i = 0;
                            i < 2 && i < notSuperWideRemaining;
                            i++
                        ) {
                            lockupBlockData.tabletOrder.push(notSuperWide[0]);
                            notSuperWide.splice(0, 1);
                            notSuperWideRemaining--;
                        }
                    }
                }
            },
            updateInfiniteScroll = function () {
                clearInfiniteScrollCall();

                infiniteScrollInit("update", lockupBlocks);
            },
            prepareForNewBlocks = function () {
                // As we're reloading all the content again from the beginning,
                // remove the body class that shows the footer
                body.classList.remove("full-page-contents-loaded");

                hidePage();

                updateInfiniteScroll();
            },
            whenBlocksVisible = function (callback) {
                if (pageContents.offsetWidth && pageContents.offsetHeight) {
                    callback();
                } else {
                    // Add the callback to the blocks visible
                    onBlocksVisible = function () {
                        callback();

                        // Reset the function when it has been called
                        onBlocksVisible = function () {};
                    };
                }
            },
            destroyPackery = function () {
                // Set the flag on the packery container
                packeryContainerEl.dataset.instance = false;

                // Destroy the instance
                pckryInstance.destroy();
            },
            sizing = function (firstLoad) {
                // If we think we are at mobile
                if (mobile) {
                    // If this is first load and we are at desktop
                    if (firstLoad && winW >= 980) {
                        // Set the flag
                        mobile = false;
                        // If not necessarily first load but we are not mobile
                    } else if (winW >= 768) {
                        // Set the flags
                        mobile = false;
                        tablet = true;

                        // Don't do this on first load
                        if (!firstLoad) {
                            whenBlocksVisible(prepareForNewBlocks);
                        }
                    }
                    // If we think we are at tablet
                } else if (tablet) {
                    // If we are actually at mobile
                    if (winW < 768) {
                        // Set the flags
                        mobile = true;
                        tablet = false;

                        whenBlocksVisible(prepareForNewBlocks);
                        // If we are actually at desktop
                    } else if (winW >= 980) {
                        // Set the flag
                        tablet = false;

                        whenBlocksVisible(prepareForNewBlocks);
                    }
                    // If we think we are at desktop
                } else {
                    // If we are actually less
                    if (winW < 980) {
                        // Set the flag
                        tablet = true;

                        whenBlocksVisible(prepareForNewBlocks);

                        // If an instance has been built, destroy it
                        if (packeryInstance()) {
                            destroyPackery();
                        }
                        // If we are in fact at desktop
                    } else {
                        // Re layout (no method given calls 'layout')
                        if (packeryInstance()) {
                            sizeLockupBlocks();

                            if (
                                lockupBlocks.offsetWidth &&
                                lockupBlocks.offsetHeight
                            ) {
                                pckryInstance.layout();
                            }
                        }
                    }
                }
            };

        lockupBlockData.defaultOrder = [];
        lockupBlockData.superWide = [];
        lockupBlockData.notSuperWide = [];
        lockupBlockData.tabletOrder = [];

        // For each block we have
        if (lockupBlockOrder) {
            lockupBlockOrder.querySelectorAll("span").forEach((el) => {
                var id = el.dataset.id,
                    superWide = el.dataset.superWide;

                // Add it to the default order array
                lockupBlockData.defaultOrder.push(id);

                // If it is a superwide
                if (superWide) {
                    // Add it to the superwide array
                    lockupBlockData.superWide.push(id);
                    // If it isn't
                } else {
                    // Add it to the not super wide array
                    lockupBlockData.notSuperWide.push(id);
                }
            });

            // We don't need this anymore, remove it
            lockupBlockOrder.remove();

            buildTabletOrder();

            // Set the global object
            packeryContainerEl = lockupBlocks;

            sizing(true);

            appendSizing(sizing);
        }
    },
    projectsInit = function (positionPageContents) {
        var slideTime = 400,
            // From the CSS
            fadeTime = 300,
            darkProject = false,
            getFadeDelay = function (separateTransitions, opening) {
                var fadeDelay = 0;

                if (opening) {
                    if (separateTransitions) {
                        fadeDelay = slideTime;
                    }
                    // If we are closing but not doing separate transitions,  wait 100ms
                    // so that the opening matches the closing
                    // (slide toggle is 100ms longer than fade)
                } else if (!separateTransitions) {
                    fadeDelay = 100;
                }

                return fadeDelay;
            },
            slideAndFade = function (container, separateTransitions, opening) {
                var slideDelay = separateTransitions && !opening ? fadeTime : 0,
                    fadeDelay = getFadeDelay(separateTransitions, opening);

                setTimeout(function () {
                    if (opening) {
                        // Open the container
                        Utils.slideDown(container, 400);
                    } else {
                        // Close the container
                        Utils.slideUp(container, 400);
                    }
                }, slideDelay);

                // Fade the text
                setTimeout(function () {
                    // Add the class to fade the text
                    container.classList.toggle("reveal");
                }, fadeDelay);
            },
            projectLinkInit = function () {
                var overlayElements = document.querySelectorAll(
                        ".js-project-container, .js-breadcrumbs"
                    ),
                    projectContainer = document.querySelector(
                        ".js-project-container"
                    ),
                    project = document.querySelector(".js-project"),
                    projectLoader =
                        document.querySelector(".js-project-loader"),
                    projectIdentifier = "project/",
                    projectIdentifierL = projectIdentifier.length,
                    currentProjectSlug,
                    fadingContent = document.querySelectorAll(
                        ".js-project-fading-content"
                    ),
                    loadingIcons =
                        document.querySelectorAll(".js-loading-icon"),
                    indexPageLoaded = lockupBlocks ? true : false,
                    projectShowing = !indexPageLoaded,
                    prevScrollT,
                    preventTransition = function () {
                        // Prevent transition on the project elements
                        overlayElements.forEach((el) =>
                            el.classList.add("prevent-transition")
                        );

                        // After the elements have been shown, re-enable the transition for next time
                        setTimeout(function () {
                            overlayElements.forEach((el) =>
                                el.classList.remove("prevent-transition")
                            );
                        }, 100);
                    },
                    showProjectContents = function () {
                        // Add the class to show the project
                        project.classList.add("reveal");
                    },
                    hideProjectContents = function () {
                        // Remove the class to hide the project
                        project.classList.remove("reveal");
                    },
                    updateScrollTop = function (val) {
                        // Set the appropriate scroll top value
                        window.scroll({ top: val });
                    },
                    pageContentsToFlow = function () {
                        // Change the document flow to the page contents
                        body.classList.remove("flow-switch");
                    },
                    projectToFlow = function () {
                        // Change the document flow to the project container
                        body.classList.add("flow-switch");
                    },
                    infiniteScrollListeners = function (projectData) {
                        EventHandler.addEventListener(
                            "resize.infiniteProject",
                            function () {
                                raf(projectData.sizing);
                            }
                        );

                        EventHandler.addEventListener(
                            "scroll.infiniteProject",
                            function () {
                                raf(projectData.scrolling);
                            }
                        );
                    },
                    setContents = function (contents, extraContents) {
                        var renderedInterval;

                        // Paste the contents into the container
                        project.innerHTML = contents;

                        // If we are adding rather than emptying
                        if (contents) {
                            // Set an interval to check when the content has rendered
                            renderedInterval = setInterval(function () {
                                // If there is content in the project
                                if (project.innerHTML.length) {
                                    // Clear the interval
                                    clearInterval(renderedInterval);

                                    // If we have extra content from infinite scroll, add that as well
                                    if (extraContents) {
                                        project
                                            .querySelector(
                                                ".js-infinite-scroll-container"
                                            )
                                            .insertAdjacentHTML(
                                                "beforeend",
                                                extraContents
                                            );
                                    }

                                    // When all the images in this project have loaded, fade it in
                                    imagesLoaded(
                                        project.querySelectorAll(
                                            ".js-layout-image"
                                        ),
                                        function () {
                                            var infiniteScrollContainer =
                                                    project.querySelector(
                                                        ".js-infinite-scroll-container"
                                                    ),
                                                slug =
                                                    infiniteScrollContainer
                                                        .dataset.slug,
                                                projectData =
                                                    projectContainer[slug];

                                            // Hide the project loader
                                            projectLoader.style.height = "";
                                            projectLoader.classList.remove(
                                                "reveal"
                                            );

                                            // Fade out the loading icons until next time
                                            loadingIcons.forEach((el) =>
                                                el.classList.remove("reveal")
                                            );

                                            showProjectContents();

                                            // If we have already set up the infinite scroll for
                                            // this project, assign the functions
                                            if (
                                                typeof projectData.sizing !==
                                                    "undefined" &&
                                                typeof projectData.scrolling !==
                                                    "undefined"
                                            ) {
                                                infiniteScrollListeners(
                                                    projectData
                                                );

                                                // If we need to show the suggested projects, show them
                                                if (projectData.allLoaded) {
                                                    document
                                                        .querySelector(
                                                            ".js-project-footer-" +
                                                                slug
                                                        )
                                                        .classList.add("show");

                                                    // Hide the loading indicator
                                                    project
                                                        .querySelector(
                                                            ".js-inf-scr-indicator"
                                                        )
                                                        .classList.add("done");
                                                }
                                            } else {
                                                // Set up and assign the infinite scroll
                                                infiniteScrollInit(
                                                    null,
                                                    infiniteScrollContainer
                                                );
                                            }
                                        }
                                    );
                                }
                            }, 100);
                        }
                    },
                    updateCurrentProject = function (
                        contents,
                        slug,
                        extraContents
                    ) {
                        setContents(contents, extraContents);

                        // Update the current project showing flag
                        currentProjectSlug = slug;
                    },
                    revealProjectOverlay = function (initialLoad) {
                        // If this is the first page load, don't transition in the overlay elements
                        if (initialLoad) {
                            preventTransition();
                        }

                        showOverlay(overlayElements);

                        // Fade in any transitioning elements
                        if (fadingContent.length) {
                            fadingContent.forEach((el) =>
                                el.classList.add("reveal")
                            );
                        }
                    },
                    hideProjectOverlay = function () {
                        var currentScrollTop = winScrollT;

                        pageContentsToFlow();

                        // If we have a packery instance
                        if (packeryInstance()) {
                            sizeLockupBlocks();

                            // Re-layout with the correct flow
                            pckryInstance.layout();
                        }

                        onBlocksVisible();

                        positionPageContents();

                        // Set the current scroll top to the project container to avoid jump
                        projectContainer.scroll({ top: currentScrollTop });

                        setTimeout(function () {
                            // Reset the previous scroll position
                            window.scroll({ top: prevScrollT });

                            hideOverlay(overlayElements);

                            // Fade out any transitioning elements
                            if (fadingContent.length) {
                                fadingContent.forEach((el) =>
                                    el.classList.remove("reveal")
                                );
                            }
                        }, 0);
                    },
                    getProject = function (slug, initialLoad) {
                        var fadeDelay = 0,
                            transitionDelay = projectOverlayTransitionT,
                            // Filter our array based on the entry id
                            foundInArray = projectArray.filter(
                                (obj) => obj.slug === slug
                            ),
                            thisProjectReturned = foundInArray.length
                                ? foundInArray[0]
                                : false;

                        // If there is currently a project showing
                        if (projectShowing) {
                            // Set the fadeDelay so othat this project can fade out first
                            fadeDelay = 300;
                            // We are not going to be transitioning
                            transitionDelay = 0;

                            hideProjectContents();
                            // If there is not currently a project showing
                        } else {
                            // Set the flag that there now is
                            projectShowing = true;
                            // Get the current scroll top value
                            prevScrollT = winScrollT;
                            // Time break to allow the previous project to be cleared on iOS
                            setTimeout(function () {
                                revealProjectOverlay(initialLoad);
                            }, 0);
                        }

                        // After the appropriate fadeDelay
                        setTimeout(function () {
                            // If we have already received this project
                            if (thisProjectReturned) {
                                // If this project is not already showing, set it
                                if (
                                    thisProjectReturned.slug !==
                                    currentProjectSlug
                                ) {
                                    hideProjectContents();

                                    // If we are sliding in the project overlay
                                    if (transitionDelay) {
                                        // Clear the contents so we don't see the old project
                                        // as we are sliding in
                                        setContents("");
                                    }
                                    // After the page has slidden in to avoide jumpiness
                                    setTimeout(function () {
                                        updateCurrentProject(
                                            thisProjectReturned.data,
                                            thisProjectReturned.slug,
                                            thisProjectReturned.extraData
                                        );
                                    }, transitionDelay);
                                    // If this project is already showing, set up the listeners
                                } else {
                                    infiniteScrollListeners(
                                        projectContainer[currentProjectSlug]
                                    );
                                }

                                // Update the variable from the object
                                darkProject =
                                    projectContainer[slug].darkProject;

                                projectContainer.scroll({ top: 0 });

                                setTimeout(function () {
                                    // If the overlay is still showing
                                    if (projectShowing) {
                                        projectToFlow();

                                        updateScrollTop(0);
                                    }

                                    showProjectContents();
                                }, transitionDelay);
                                // If we haven't already received this project
                            } else {
                                // If we are not fading out the current project, remove it
                                // to prevent flash on sliding in
                                if (!fadeDelay) {
                                    setContents("");
                                }

                                hideProjectContents();

                                // When the project is showing if sliding in, or straight away if not
                                setTimeout(function () {
                                    // Set the scroll top to the top of the page so we can see
                                    // the loading indicator
                                    updateScrollTop(0);
                                }, projectOverlayTransitionT);

                                // Show the loading
                                projectLoader.style.height = winH;
                                projectLoader.classList.add("reveal");

                                // After the page background colour has transitioned with a bit
                                // of breathing room to prevent a flash of colour if the
                                // transition hasn't quite finished
                                setTimeout(function () {
                                    // Fade in the loading icon
                                    loadingIcons.forEach((el) =>
                                        el.classList.add("reveal")
                                    );
                                }, 500);

                                // Make a call for it
                                axios
                                    .post(
                                        `/project/ajax`,
                                        { slug: slug },
                                        {
                                            headers: {
                                                "X-Requested-With":
                                                    "XMLHttpRequest",
                                            },
                                        }
                                    )
                                    .then(function (response) {
                                        // Append items to list
                                        // let returnData = Utils.stringToHTML(
                                        //     response.data
                                        // );
                                        let returnData = response.data;

                                        updateCurrentProject(returnData, slug);

                                        // If the overlay is still showing
                                        if (projectShowing) {
                                            projectToFlow();
                                        }

                                        // Add this project data to the array
                                        projectArray.push({
                                            slug: slug,
                                            data: returnData,
                                            extraData: "",
                                        });
                                    })
                                    .catch(function (error) {
                                        console.error(error);
                                    });

                                // Create an empty object to house the project data
                                projectContainer[slug] = {};
                            }

                            // This timeout prevents iOS flashing the previous project if the
                            // background colour is changing when loading in a new project
                            setTimeout(function () {
                                // Add / remove the background class depending on the colour of this project
                                if (darkProject) {
                                    body.classList.add(
                                        "page-overlay_background-dark"
                                    );

                                    // Assign the background colour for future use
                                    projectContainer[slug].darkProject =
                                        darkProject;
                                } else {
                                    body.classList.remove(
                                        "page-overlay_background-dark"
                                    );
                                }
                            }, 0);
                        }, fadeDelay);
                    },
                    getProjectSlug = function (path) {
                        var slug = false;

                        // If this path begins with the project identifier
                        if (
                            path.substring(0, projectIdentifierL) ===
                            projectIdentifier
                        ) {
                            // Get everything after the project identifier
                            slug = path.substring(projectIdentifierL);
                        }

                        return slug;
                    },
                    updateProjectShowing = function (modifier) {
                        var projectSlug,
                            initialLoad = modifier === "initial-load";

                        // On first load
                        if (initialLoad) {
                            projectSlug = project.dataset.slug;

                            // If the index page isn't loaded
                            if (!indexPageLoaded) {
                                // Add the current project to the array for future use
                                projectArray.push({
                                    slug: projectSlug,
                                    data: project.innerHTML,
                                    extraData: "",
                                });

                                // Create the global object
                                projectContainer[projectSlug] = {
                                    darkProject: project.dataset.darkProject,
                                };

                                // don't parse this static url
                                return;
                            }
                        } else {
                            // Remove any previous project listeners
                            [
                                "resize.infiniteProject",
                                "scroll.infiniteProject",
                            ].forEach((event) => {
                                EventHandler.removeEventListener(event);
                            });
                        }

                        // Get a project slug from the URL
                        projectSlug = getProjectSlug(parseUrl());

                        // If a slug was returned
                        if (projectSlug) {
                            getProject(projectSlug, initialLoad);
                            // Otherwise, if this is the first load
                        } else if (!initialLoad) {
                            // Set the flag
                            projectShowing = false;

                            hideProjectOverlay();
                        }
                    },
                    hideItemOverlay = function (el) {
                        el.classList.remove("hover-state");
                    },
                    fillWinH = function () {
                        projectContainer.style.minHeight = winH;
                    };

                // If this browser supports the history API and a project was found in the hash
                if (
                    parseHash().substring(0, projectIdentifierL) ===
                    projectIdentifier
                ) {
                    // Replace to remove the hash
                    window.history.replaceState(
                        stateObj,
                        null,
                        "/" + window.location.hash.substring(1)
                    );
                }

                fillWinH();

                appendSizing(fillWinH);

                updateProjectShowing("initial-load");

                // On a hashchange, parse it
                window.addEventListener("hashchange  popstate", function (e) {
                    // Prevent jumping if this is the work hash
                    e.preventDefault();

                    // If this is a popstate
                    if (e.type === "popstate") {
                        // If this is running on page load (happens in certain browsers), don't allow it
                        if (!e.originalEvent.state) {
                            return;
                        }

                        // If the state we are returning to is from a previous page load
                        if (e.originalEvent.state.time !== stateObj.time) {
                            // Reload this page as the popstate change won't take us back to work
                            window.location.reload();

                            // Don't go on
                            return;
                        }
                    }

                    updateProjectShowing();
                });

                // Don't allow body scrolls on scrolling project loader
                projectLoader.addEventListener(
                    "mousewheel  DOMMouseScroll  MozMousePixelScroll  " +
                        touchMoveEvents,
                    (e) => {
                        e.preventDefault();
                    }
                );

                /**
                 * For touch devices we want to reveal the project thumbnail overlay
                 * on touchend
                 */
                // ["click", "touchend"].forEach((event) => {
                ["click"].forEach((event) => {
                    body.addEventListener(
                        event,
                        (e) => {
                            var $this = e.target.closest(".js-item-overlay");

                            // Have we clicked/touched something other than a project thumbnail?
                            if (!$this) {
                                // If yes, hide any visible overlays
                                document
                                    .querySelectorAll(
                                        ".js-item-overlay.hover-state"
                                    )
                                    .forEach((el) => hideItemOverlay(el));

                                return;
                            }

                            if (
                                touchDevice &&
                                !$this.classList.contains("hover-state")
                            ) {
                                // If this overlay doesn't have the hover state
                                // Hide any other active overlays
                                const els = [
                                    ...document.querySelectorAll(
                                        ".js-item-overlay.hover-state"
                                    ),
                                ].filter((item) => item !== $this);

                                els.forEach((el) => hideItemOverlay(el));

                                // Add it to this one
                                $this.classList.add("hover-state");

                                return;
                            }

                            const overlayVisible = window
                                .getComputedStyle(
                                    $this.querySelector(".js-overlay-smoke")
                                )
                                .getPropertyValue("opacity");
                            if (overlayVisible == 1) {
                                // If this overlay has the hover state, or the overlay is visible
                                // check whether this was a click on the video link
                                // Do nothing to let other event handler manage loading and showing the video
                                if (e.target.closest(".js-play-video-link")) {
                                    return;
                                }

                                // Click was elsewhere in the overlay or on the project link...
                                // Trigger a click on the appropriate link
                                if ($this.classList.contains("video-only")) {
                                    // Click the contained video link
                                    $this
                                        .querySelector(".js-play-video-link")
                                        .click();
                                } else {
                                    // Click the contained project link
                                    $this
                                        .querySelector(".js-project-link")
                                        .click();
                                }
                            }
                        },
                        false
                    );
                });

                /**
                 * On clicking a project link dynamically request
                 * and reveal the full project page
                 */
                body.addEventListener(
                    "click",
                    (e) => {
                        var $this = e.target.closest(".js-project-link");

                        if ($this) {
                            var entrySlug = $this.dataset.projectSlug;

                            e.preventDefault();

                            if (preventAction) {
                                return;
                            }

                            // Update the dark flag
                            darkProject = $this.dataset.projectDark;

                            // Push it
                            window.history.pushState(
                                stateObj,
                                null,
                                window.location.origin +
                                    "/" +
                                    projectIdentifier +
                                    entrySlug
                            );

                            updateProjectShowing();
                        }
                    },
                    false
                );

                /**
                 * On clicking a project credits link
                 * (this is a separate handler to the project link as we don't want to
                 * trigger the project link handler when clicking a video link)
                 */
                body.addEventListener(
                    "click",
                    function (e) {
                        var $this = e.target.closest(".js-credits-link");

                        if ($this) {
                            var credits = document.querySelector(".js-credits"),
                                opening = !$this.classList.contains("js-open"),
                                targetText = opening
                                    ? "Close Credits"
                                    : "View Credits";

                            e.preventDefault();

                            // Toggle the class flag on the link
                            $this.classList.toggle("js-open");

                            slideAndFade(credits, false, opening);

                            if (opening) {
                                setTimeout(function () {
                                    var offset = credits.offsetTop,
                                        // Target is such that the bottom of the credits are visible
                                        target =
                                            offset +
                                            credits.clientHeight -
                                            winH;

                                    // If the current scroll position is less than the target, animate,
                                    // but not further than the top with some breathing space
                                    if (winScrollT < target) {
                                        animateBody(
                                            Math.min(target, offset - 20)
                                        );
                                    }
                                }, slideTime);
                            }

                            // Set the text
                            $this.querySelector(
                                ".js-credits-link-text"
                            ).textContent = targetText;
                        }
                    },
                    false
                );

                /**
                 * On clicking a project sharing link
                 * (this is a separate handler to the project link as we don't want to
                 * trigger the project link handler when clicking a video link)
                 */
                body.addEventListener(
                    "click",
                    function (e) {
                        var $this = e.target.closest(".js-sharing-link");

                        if ($this) {
                            e.preventDefault();

                            // Open it in a pop up window
                            window.open(
                                $this.href,
                                "mywin",
                                "left=500,top=300,width=500,height=400,toolbar=1,resizable=0"
                            );
                        }
                    },
                    false
                );

                /**
                 * On clicking either a close project link, or a play lighbox video link
                 */
                body.addEventListener(
                    "click",
                    (e) => {
                        var $this = e.target.closest(
                            ".js-close-project-link, .js-play-video-link"
                        );

                        if ($this) {
                            // For each iframe in the project
                            document
                                .querySelectorAll(".js-project iframe")
                                .forEach((el) => {
                                    // Pause it
                                    var player = new Player(el);

                                    player.pause();
                                });
                        }
                    },
                    false
                );

                // If we have the index page loaded (i.e. not come straight to a project page)
                if (indexPageLoaded) {
                    // On clicking a close project link
                    body.addEventListener(
                        "click",
                        function (e) {
                            if (e.target.closest(".js-close-project-link")) {
                                e.preventDefault();

                                // Just move to the home page
                                window.history.pushState(
                                    stateObj,
                                    null,
                                    window.location.origin
                                );

                                // Manually parse the URL as this doesn't trigger the popstate event
                                updateProjectShowing();
                            }
                        },
                        false
                    );
                }
            };

        projectLinkInit();
    },
    infiniteScrollInit = function (modifier, el) {
        var infiniteScrollContainer = el
                ? el
                : document.querySelector(".js-infinite-scroll-container"),
            isLockupBlocks = infiniteScrollContainer.dataset.lockupBlocks,
            isProject = infiniteScrollContainer.dataset.project,
            template = infiniteScrollContainer.dataset.template,
            totalResults = infiniteScrollContainer.dataset.totalResults,
            namespace = "infinite",
            projectContainer = document.querySelector(".js-project-container"),
            target,
            loading = false,
            currentItems = 0,
            loadingIndicator = infiniteScrollContainer.nextElementSibling,
            replace = modifier === "update",
            slug = isProject ? infiniteScrollContainer.dataset.slug : false,
            getCurrentItems = function () {
                currentItems =
                    infiniteScrollContainer.querySelectorAll(
                        ".js-inf-scr-item"
                    ).length;
            },
            calcScrollTarget = function () {
                // Target is the bottom of the container minus half a window height so the page
                // can start loading before the user gets to the bottom
                target =
                    infiniteScrollContainer.offsetTop +
                    infiniteScrollContainer.clientHeight -
                    winH * 0.5;
            },
            removeListeners = function () {
                ["scroll." + namespace, "resize." + namespace].forEach(
                    (event) => {
                        if (event === "scroll." + namespace) {
                            EventHandler.removeEventListener(event);
                        }

                        if (event === "resize." + namespace) {
                            EventHandler.removeEventListener(event, "window");
                        }
                    }
                );
            },
            weHaveAllResults = function () {
                // If we have all the results, or the total results request failed
                return (
                    currentItems >= totalResults ||
                    typeof totalResults === "undefined"
                );
            },
            onAllResults = function () {
                removeListeners();

                // Hide the loading indicator
                loadingIndicator.classList.add("done");

                // If this is a project, empty the functions
                if (isProject) {
                    projectContainer[slug].sizing = function () {};
                    projectContainer[slug].scrolling = function () {};

                    // Let the new images render first
                    setTimeout(function () {
                        projectContainer[slug].allLoaded = true;

                        // Show the suggested projects
                        // Hide the loading indicator
                        document
                            .querySelectorAll(".js-project-footer-" + slug)
                            .forEach((el) => el.classList.add("show"));
                    }, 20);
                } else {
                    // Add a class to the body to indicate all content loaded...
                    body.classList.add("full-page-contents-loaded");
                }
            },
            loadItems = function () {
                var postData = {};

                // Clear any calls as a result of very fast page resizing
                clearInfiniteScrollCall();

                // If this is the lockup blocks infinite scroll
                if (isLockupBlocks) {
                    // Mobile - use default order
                    if (winW < 768) {
                        postData.ids = lockupBlockData.defaultOrder.slice(
                            currentItems,
                            currentItems + 9
                        );

                        postData.layout = "mobile";
                        // Tablet - use tablet order
                    } else if (winW < 980) {
                        postData.ids = lockupBlockData.tabletOrder.slice(
                            currentItems,
                            currentItems + 9
                        );

                        postData.layout = "tablet";
                        // Desktop - use default order
                    } else {
                        postData.ids = lockupBlockData.defaultOrder.slice(
                            currentItems,
                            currentItems + 9
                        );

                        postData.layout = "desktop";
                    }
                    // If it is not, use the current item count
                } else {
                    postData.offset = currentItems;
                }

                // If this is a project infinite scroll, get the project's slug
                if (isProject) {
                    postData.slug = infiniteScrollContainer.dataset.slug;
                }

                infiniteScrollAjaxCall = new AbortController();

                axios
                    .post(`/includes/${template}`, postData, {
                        signal: infiniteScrollAjaxCall.signal,
                        headers: { "X-Requested-With": "XMLHttpRequest" },
                    })
                    .then(function (response) {
                        // Append items to list
                        const newContent = Utils.stringToHTML(response.data);

                        // Add the newly aquired blocks to the container
                        const newBlocks =
                            newContent.querySelectorAll(".js-inf-scr-item");

                        const contentLoaders =
                            newContent.querySelectorAll(".js-item-loader");

                        // If this is a project and the container has previously been replaced
                        if (
                            isProject &&
                            !(
                                infiniteScrollContainer.offsetWidth &&
                                infiniteScrollContainer.offsetHeight
                            )
                        ) {
                            // Re-assign the correct container
                            infiniteScrollContainer = [
                                ...document.querySelectorAll(
                                    ".js-infinite-scroll-container"
                                ),
                            ].filter((el) => el.dataset.slug === slug)[0];
                        }

                        if (!infiniteScrollContainer) {
                            return;
                        }

                        // If we are replacing
                        // if (replace) {
                        //     replace = false;

                        //     // Remove all existing container before adding new content
                        //     infiniteScrollContainer.innerHTML = "";
                        // }

                        // Add the new content to the container
                        newBlocks.forEach((el) => {
                            // Add a class to hide the new blocks while they are loading
                            el.classList.add("hide-until-load");

                            // Append to the container
                            infiniteScrollContainer.append(el);
                        });

                        // When all the new images have loaded
                        imagesLoaded(
                            infiniteScrollContainer.querySelectorAll(
                                ".js-layout-image"
                            ),
                            function () {
                                var projectData;

                                // Remove the class to show the new blocks
                                infiniteScrollContainer
                                    .querySelectorAll(".js-inf-scr-item")
                                    .forEach((el) => {
                                        el.classList.remove("hide-until-load");
                                    });

                                // If this is the work page
                                if (isLockupBlocks) {
                                    // If we have a packery instance, layout the new items
                                    if (postData.layout === "desktop") {
                                        if (packeryInstance()) {
                                            sizeLockupBlocks(newBlocks);

                                            pckryInstance.appended(newBlocks);
                                            pckryInstance.layout();
                                            // If we don't, but this page needs one and we are at desktop, set it up
                                        } else if (
                                            packeryContainerEl &&
                                            winW >= 980
                                        ) {
                                            buildPackery();
                                        }
                                    } else {
                                        // We only need packery at desktop, otherwise destroy any instance
                                        if (packeryInstance()) {
                                            pckryInstance.destroy();
                                        }
                                    }
                                }

                                // If the new content has an item loader, add them to the listener
                                if (
                                    window.appendTransitioningBlocks &&
                                    contentLoaders.length
                                ) {
                                    window.appendTransitioningBlocks(
                                        contentLoaders
                                    );
                                }

                                // If we have been given the play video sizing function, run it
                                if (window.playVideoSizing) {
                                    window.playVideoSizing(newBlocks);
                                }

                                showPage();

                                getCurrentItems();

                                // Add the new data to the project array if this is an ajaxed project
                                if (isProject && projectArray.length) {
                                    projectData = projectArray.filter(
                                        (obj) => obj.slug === slug
                                    )[0];

                                    projectData.extraData += response.data;
                                }

                                // If we now have all the results
                                if (weHaveAllResults()) {
                                    onAllResults();

                                    return;
                                }

                                calcScrollTarget();

                                // Set the flag for this load is done
                                loading = false;
                            }
                        );
                    })
                    .catch(function (error) {
                        console.error(error);
                    });
            },
            loadIfCorrectPosition = function () {
                // If this is the main listener and the page contents are not visible, don't
                // go on
                // if (
                //     isLockupBlocks &&
                //     !(pageContents.offsetWidth && pageContents.offsetHeight)
                // ) {
                //     return;
                // }

                // If we are in the target zone
                if (winH >= target - winScrollT) {
                    // If we are still loading from the last call, don't go on
                    if (loading) {
                        return;
                    }

                    // Set the flag for loading
                    loading = true;

                    loadItems();
                }
            };

        if (isLockupBlocks) {
            namespace += "Main";
        } else if (isProject) {
            namespace += "Project";
        }

        // If this is an update, remove the previous listeners
        if (replace) {
            removeListeners();

            // Re-show the loading indicator if the previous inf scroll was complete
            // and hide it if the previous instance had added the reveal class
            loadingIndicator.classList.remove("reveal", "done");
            loadingIndicator.classList.add("prevent-flash");

            // After the page has faded out, remove the flash prevention
            setTimeout(function () {
                loadingIndicator.classList.remove("prevent-flash");
            }, 300);

            // Ensure any sizing / scrolling functions which have been triggered by a listener
            // but are running in a RAF (and possibly will fire after the listeners are
            // cleared) do see the page as no height from the clearning and so trigger
            // the loading. e.g. resize -> window waits for an animation frame to run the
            // sizing function, -> clear html -> sizing function fires and sees that we
            // should update.
            setTimeout(function () {
                infiniteScrollContainer.innerHTML = "";
            }, 4);
        } else {
            getCurrentItems();
        }

        // If we already have all the results, don't go on
        if (weHaveAllResults()) {
            onAllResults();

            return;
        }

        imagesLoaded(
            infiniteScrollContainer.querySelectorAll(".js-layout-image"),
            function () {
                var sizing = function () {
                        if (infiniteScrollContainer) {
                            calcScrollTarget();

                            loadIfCorrectPosition();
                        }
                    },
                    scrolling = function () {
                        loadIfCorrectPosition();
                    };

                sizing();

                EventHandler.addEventListener(
                    "scroll." + namespace,
                    function () {
                        raf(scrolling);
                    }
                );

                EventHandler.addEventListener(
                    "resize." + namespace,
                    function () {
                        raf(sizing);
                    },
                    "window"
                );

                // If this is a project, we need to assign the functions to the container for
                // later use
                if (isProject) {
                    projectContainer[slug].sizing = sizing;
                    projectContainer[slug].scrolling = scrolling;
                }
            }
        );
    },
    // A simpler, more generic version of what the news orphan prevention acheives
    preventOrphans = function (els) {
        els.forEach((el) => {
            var textArray = el.innerHTML.split(" "),
                textArrayL = textArray.length;

            // If we don't have more than 2 words, don't do anything
            if (textArrayL < 3) {
                return true;
            }

            var textString = "";

            // Add all bar the last 2 words
            for (var i = 0; i < textArrayL - 2; i++) {
                textString += " " + textArray[i];
            }

            // Wrap the last 2 words in a stylable span
            textString +=
                ' <span class="keep-together">' +
                textArray[textArrayL - 2] +
                " " +
                textArray[textArrayL - 1] +
                "</span>";

            el.innerHTML = textString;
        });
    },
    pageInit = function () {
        var lockupBlocksOnPage = lockupBlocks ? true : false,
            positionPageContents;

        // If this is not the Android stock browser, add the class for nicer text rendering
        if (!userAgent.androidStock) {
            body.classList.add("optimise-legibility");
        }

        sizing();

        scrolling();

        setInterval(function () {
            winScrollT = window.scrollY;
        }, 10);

        generalListenersInit();

        if (document.querySelector(".js-info")) {
            positionPageContents = infoBar.init();
        }

        workLinkInit();

        // If we have image transitions, initialize
        if (
            lockupBlocksOnPage ||
            document.querySelectorAll(".js-item-loader").length
        ) {
            imageTransitionInit();
        }

        // If we have the lockup blocks or a stand alone project page, initialize the project / news functionality
        if (
            lockupBlocksOnPage ||
            document.querySelectorAll(".js-project").length
        ) {
            blocksInit();

            projectsInit(positionPageContents);
        }

        // If we have a video overlay, initialize
        if (document.querySelectorAll(".js-video-overlay").length) {
            Videos.init();
        }

        // If we have an infinite scroll, initialize
        if (document.querySelectorAll(".js-infinite-scroll-container").length) {
            infiniteScrollInit();
        }

        preventOrphans(document.querySelectorAll(".js-p-o"));

        if (document.querySelectorAll(".js-job-link").length) {
            Jobs.init();
        }

        // If this is not the work page
        if (!lockupBlocksOnPage) {
            // When every image which affects page layout has loaded in correctly
            imagesLoaded(
                document.querySelectorAll(".js-layout-image"),
                function () {
                    // Show the page
                    showPage();
                }
            );
        }

        // Attach click event listener to foot logo to scroll to top of page
        if (scrollTop) {
            scrollTop.addEventListener("click", function () {
                animateBody(0);
            });
        }
    };

// If we don't support window.location.origin, polyfill
if (!window.location.origin) {
    window.location.origin =
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : "");
}

// Replace the current state with our obj for popchange test
window.history.replaceState(stateObj, null);

userAgent.android = userAgent.string.indexOf("android") > -1;
userAgent.iOS = /(ipad|iphone|ipod)/g.test(userAgent.string);

if (userAgent.android) {
    userAgent.androidChrome = userAgent.string.indexOf("chrome") > -1;
    userAgent.androidStock =
        !userAgent.androidChrome &&
        userAgent.string.indexOf("mozilla/5.0") > -1 &&
        userAgent.string.indexOf("applewebkit") > -1;
}

// If this is ie, add a class to the body
if (
    userAgent.string.indexOf("msie") > -1 ||
    !!userAgent.string.match(/trident.*rv\:11\./)
) {
    body.classList.add("ie");
}

pageInit();
